// Basic consent mode: no Google script or requests until an explicit opt-in.
export const MEASUREMENT_ID = 'G-KW2ZE6QN4F';
export const ANALYTICS_HOSTS = ['dvilladsen.com', 'www.dvilladsen.com'];

export function createAnalytics(win = window, doc = document) {
  let enabled = false;
  let loaded = false;
  let lastLocation = null;
  const disableKey = `ga-disable-${MEASUREMENT_ID}`;
  win[disableKey] = true;
  win.dataLayer = win.dataLayer || [];
  const gtag = function () { win.dataLayer.push(arguments); };
  win.gtag = gtag;
  gtag('consent', 'default', {
    analytics_storage: 'denied', ad_storage: 'denied',
    ad_user_data: 'denied', ad_personalization: 'denied',
  });

  function pageView() {
    if (!enabled) return;
    // Avoid sending query strings or hashes, which can contain personal data.
    const location = win.location.origin + win.location.pathname;
    if (location === lastLocation) return;
    const previous = lastLocation;
    lastLocation = location;
    gtag('event', 'page_view', {
      page_location: location, page_title: doc.title,
      page_referrer: previous || '',
    });
  }

  function setConsent(accepted) {
    if (accepted === enabled) return;
    enabled = accepted;
    win[disableKey] = !accepted;
    if (!accepted) {
      // Stop even an already-loaded tag immediately, then unload it. Do not
      // send a denied-consent ping after withdrawal in basic consent mode.
      win.location.reload();
      return;
    }
    gtag('consent', 'update', { analytics_storage: 'granted' });
    if (!loaded) {
      loaded = true;
      gtag('js', new Date());
      gtag('config', MEASUREMENT_ID, {
        send_page_view: false,
        allow_google_signals: false,
        allow_ad_personalization_signals: false,
        cookie_domain: win.location.hostname,
        cookie_expires: 60 * 60 * 24 * 182,
        page_location: win.location.origin + win.location.pathname,
        page_referrer: '',
      });
      const script = doc.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
      doc.head.appendChild(script);
    }
    pageView();
  }
  return { setConsent, pageView };
}
